import API from '../../../apis/kogan-api';


export const getCategories = (searchStr) => {
    return API.get(`categories/ebay?searchStr=${searchStr}`);
  };